<template>
  <v-container fluid>
    <a-form layout="vertical">
      <a-row :gutter="8">
        <a-col :span="24" :xxl="3" :xl="4" :lg="6" :md="8">
          <a-form-item label="车牌号/司机/挂厢号">
            <a-textarea v-model="queryForm.text" placeholder="车牌号/司机/挂厢号"
              :auto-size="{ minRows: 4, maxRows: 4 }"></a-textarea>
          </a-form-item>
        </a-col>
        <a-col :span="24" :xxl="21" :xl="20" :lg="18" :md="16">
          <a-row :gutter="4">
            <a-col :span="24" :xxl="4" :xl="6" :lg="8" :md="12">
              <a-form-item label="日期">
                <a-range-picker v-model="queryForm.day_range" :mode="['date', 'date']" :placeholder="['开始日期', '结束日期']"
                  :locale="locale" :allowClear="false" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
                  style="width:100%;" />
              </a-form-item>
            </a-col>
            <!-- <a-col :span="24" :xxl="2" :xl="3" :lg="4" :md="6">
              <a-form-item label="派押局">
                <a-select v-model="queryForm.postofficeid" :options="spostoffices" :allowClear="true" placeholder="请选择"
                  style="width:100%;">
                </a-select>
              </a-form-item>
            </a-col> -->
            <a-col :span="24" :xxl="2" :xl="3" :lg="4" :md="6">
              <a-form-item label="单程/往返">
                <a-select v-model="queryForm.postroutelevel" :options="[
                  { label: '单程', value: '单程' },
                  { label: '往返', value: '往返' }
                ]" :allowClear="true" placeholder="请选择" style="width:100%;">
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24" :xxl="2" :xl="3" :lg="4" :md="6">
              <a-form-item label="车辆状态">
                <a-select v-model="queryForm.vehicle_state" :options="vehicle_states" :allowClear="true"
                  placeholder="请选择" style="width:100%;">
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24" :xxl="2" :xl="3" :lg="4" :md="6">
              <a-form-item label="所属类型">
                <a-select v-model="queryForm.own_type" :options="own_types" :allowClear="true" placeholder="请选择"
                  style="width:100%;">
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24" :xxl="2" :xl="3" :lg="4" :md="6">
              <a-form-item label="所属标段">
                <a-select v-model="queryForm.section" :options="sections" :allowClear="true" placeholder="请选择"
                  style="width:100%;">
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24" :xxl="2" :xl="3" :lg="4" :md="6">
              <a-form-item label="线路">
                <a-input v-model="queryForm.postline" placeholder="线路" style="width:100%;" />
              </a-form-item>
            </a-col>
            <a-col :span="24" :xxl="2" :xl="3" :lg="4" :md="6">
              <a-form-item label=".">
                <a-space>
                  <a-button @click="getdata()" type="primary">
                    查询
                  </a-button>
                  <a-button @click="getdata('download')">
                    下载调度计划
                  </a-button>
                  <a-button @click="add">
                    新增调度计划
                  </a-button>
                </a-space>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-button-group>
                <a-button v-for="item in spostoffices" :key="item.value"
                  :type="queryForm.postofficeid === item.value ? 'primary' : ''" @click="() => {
                    queryForm.postofficeid = item.value;
                    getdata();
                  }">
                  {{ item.label }}
                </a-button>
              </a-button-group>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-form>
    <v-card tile class="mt-2">
      <a-table size="small" bordered :columns="headers" :data-source="list" :pagination="false"
        :locale="{ emptyText: '暂无数据' }" :scroll="{ x: width, y: height }" row-key="_id">
        <template slot="title">
          <div class="d-flex align-center pl-2">
            <span>共 {{ length }} 页 / {{ count }} 条数据</span>
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small outlined v-bind="attrs" v-on="on" class="ml-2 grey lighten-3">
                  {{ limit }}/页
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in pages" @click="limit = item.value" :key="index">
                  <v-list-item-title>{{ item.value }}/页</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
        <template slot="index" slot-scope="text, record, index">
          {{ index + 1 }}
        </template>
        <template slot="dispatch_no" slot-scope="text, record">
          <template v-if="record.dispatch_no">
            {{ record.dispatch_no }}
          </template>
          <template v-else>
            <a-input v-model="record.dispatch_no2" placeholder="派车单号" @blur="saveDispatch_no(record)"></a-input>
          </template>
        </template>
        <template slot="linename" slot-scope="text, record">
          <p>{{ record.linename }}[{{ record.transport_kind }}]</p>
          <template v-if="record.transport_kind === '往返'">
            <p v-if="username !== 'root'">{{ record.transport_kind2 }}</p>
            <a-dropdown v-else>
              <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                <span :class="{
                  'error--text': record.transport_kind2 === '去程',
                  'success--text': record.transport_kind2 === '返程',
                }">{{ record.transport_kind2 || '无' }}</span>
                <a-icon type="down" />
              </a>
              <a-menu slot="overlay" @click="(e) => changeTransportKind2(record._id, e.key)">
                <a-menu-item v-if="record.transport_kind2 !== '去程'" key="去程">
                  <a href="javascript:;">去程</a>
                </a-menu-item>
                <a-menu-item v-if="record.transport_kind2 !== '返程'" key="返程">
                  <a href="javascript:;">返程</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </template>
        </template>
        <template slot="vehicle_state" slot-scope="text, record">
          <span v-if="record.vehicle_state === 4" class="success--text">已到达</span>
          <a-dropdown v-else>
            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
              <span v-if="record.vehicle_state === 1" class="error--text">空车等待</span>
              <span v-if="record.vehicle_state === 2" class="orange--text">装车中</span>
              <span v-if="record.vehicle_state === 3" class="primary--text">行驶中</span>
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay" @click="(e) => changeVehicleState(record._id, e.key)">
              <a-menu-item v-if="record.vehicle_state === 1" :key="2">
                <a href="javascript:;">装车中</a>
              </a-menu-item>
              <a-menu-item v-if="record.vehicle_state === 2" :key="3">
                <a href="javascript:;">行驶中</a>
              </a-menu-item>
              <a-menu-item v-if="record.vehicle_state === 3" :key="4">
                <a href="javascript:;">已到达</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
        <template slot="H_vehicle_time">
          <p class="orange--text">装车时间</p>
          <p class="primary--text">出发时间</p>
          <p class="success--text">到达时间</p>
        </template>
        <template slot="vehicle_time" slot-scope="text, record">
          <p class="orange--text">{{ record.load_time }}</p>
          <p class="primary--text">{{ record.departure_time }}</p>
          <p class="success--text">{{ record.arrival_time }}</p>
        </template>
        <template slot="task_state" slot-scope="text, record">
          <span v-if="record.task_state === 2" class="success--text">已下单</span>
          <a-dropdown v-else>
            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
              <span class="error--text">未下单</span>
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay" @click="(e) => changeTaskState(record._id, e.key)">
              <a-menu-item v-if="record.task_state === 1" :key="2">
                <a href="javascript:;">已下单</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
        <template slot="gps_state" slot-scope="text, record">
          <a-dropdown>
            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
              <span class="black--text">{{ record.gps_state === 1 ? '自带在线' : '' }}{{ record.gps_state ===
                2 ? '公司在线' : '' }}{{ record.gps_state === 3 ? '已归还' : '' }}</span>
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay" @click="(e) => changeGpsState(record._id, e.key)">
              <a-menu-item v-if="record.gps_state !== 1" :key="1">
                <a href="javascript:;">自带在线</a>
              </a-menu-item>
              <a-menu-item v-if="record.gps_state !== 2" :key="2">
                <a href="javascript:;">公司在线</a>
              </a-menu-item>
              <a-menu-item v-if="record.gps_state !== 3" :key="3">
                <a href="javascript:;">已归还</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
        <template slot="vehicle_number" slot-scope="text, record">
          <p>{{ record.vehicle_number }}</p>
          <a-space v-if="username === 'root'">
            <v-btn icon outlined x-small color="success" @click="() => {
              queryForm.text = record.vehicle_number;
              getdata();
            }">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <v-btn icon outlined x-small color="error" @click="() => {
              queryForm.text = '';
              getdata();
            }">
              <v-icon>mdi-minus</v-icon>
            </v-btn>
          </a-space>
          <p v-if="record.vehicle_onumber" class="error--text">{{ record.vehicle_onumber }}</p>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-space>
            <v-btn text tile color="success" @click="edit(record)"> 编辑 </v-btn>
            <a-popconfirm title="确认删除调度?" ok-text="确定" cancel-text="取消" @confirm="remove(record._id)" placement="left">
              <v-btn text tile color="error"> 删除 </v-btn>
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
      <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
    </v-card>
    <v-dialog v-model="model" persistent max-width="580px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            {{ modeltitle }}
            <v-icon @click="cancelsave">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container style="max-height:600px;overflow-y: auto;">
              <v-row>
                <v-col cols="6">
                  <v-autocomplete v-model="form.postofficeid" :items="postoffices" :rules="[vrules.required]"
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense>
                    <template v-slot:label>
                      派押局 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete v-model="form.postlineid" :items="flines" :rules="[vrules.required]"
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense>
                    <template v-slot:label>
                      线路 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-menu ref="plan_date_menu" v-model="plan_date_menu" :close-on-content-click="false"
                    :return-value.sync="form.plandate" transition="scale-transition" min-width="auto" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="form.plandate" :rules="[vrules.required]" label="计划日期"
                        append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" dense outlined>
                        <template v-slot:label>
                          计划日期 <span class="red--text">*</span>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="form.plandate" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
                      @input="() => { $refs.plan_date_menu.save(form.plandate); plan_date_menu = false; }"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete v-model="form.vehicleid" :items="vehicles1" :rules="[vrules.required]"
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense
                    @change="changeVehicle">
                    <template v-slot:label>
                      车牌号 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="6" v-if="form.vehicletype === 1 || form.vehicletype === 3">
                  <v-autocomplete v-if="form.vehicletype === 1" v-model="form.vehiclegid" :items="vehicles2"
                    :rules="[vrules.required]" :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined
                    dense>
                    <template v-slot:label>
                      挂箱号 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                  <v-text-field v-if="form.vehicletype === 3" v-model="form.vehicle_gnumber" label="挂箱号" readonly dense
                    outlined>
                    <template v-slot:label>
                      挂箱号
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete v-model="form.driverid" :items="drivers" :rules="[vrules.required]"
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense>
                    <template v-slot:label>
                      司机 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete v-model="form.task_state" :items="task_states"
                    :rules="username !== 'root' ? [vrules.required] : []" :menu-props="{ bottom: true, offsetY: true }"
                    no-data-text="无" outlined dense>
                    <template v-slot:label>
                      任务状态 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete v-model="form.gps_state" :items="gps_states"
                    :rules="username !== 'root' ? [vrules.required] : []" :menu-props="{ bottom: true, offsetY: true }"
                    no-data-text="无" outlined dense>
                    <template v-slot:label>
                      GPS状态 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.price" :rules="username !== 'root' ? [vrules.required] : []" type="number"
                    suffix="元" dense outlined>
                    <template v-slot:label>
                      <span class="red--text">运价 *</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.platform" dense outlined>
                    <template v-slot:label>
                      物流平台
                    </template>
                  </v-text-field>
                  <!-- <v-autocomplete v-model="form.platform" :items="platforms"
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense>
                    <template v-slot:label>
                      物流平台
                    </template>
                  </v-autocomplete> -->
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.platform_no" dense outlined>
                    <template v-slot:label>
                      平台单号
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="form.dispatch_no" dense outlined>
                    <template v-slot:label>
                      派车单号
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea v-model="form.remark" rows="4" dense outlined>
                    <template v-slot:label>
                      备注
                    </template>
                  </v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" tile :disabled="!valid" @click="save">确定</v-btn>
            <v-btn tile @click="cancelsave">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="updateModel" persistent max-width="400px">
      <v-form ref="updateform">
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            修改车辆状态
            <v-icon @click="cancelupdate">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container style="max-height:600px;overflow-y: auto;">
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="updateForm.state" readonly dense outlined>
                    <template v-slot:label>
                      状态
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="updateForm.timevalue" dense outlined>
                    <template v-slot:label>
                      {{ updateForm.timekey }}
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" tile @click="doUpdate">确定</v-btn>
            <v-btn tile @click="cancelupdate">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "underscore";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { mapState } from "vuex";
export default {
  name: "Dispatchplan",
  data() {
    return {
      locale,
      pages: [
        { text: "20/页", value: 20 },
        { text: "50/页", value: 50 },
        { text: "100/页", value: 100 },
        { text: "200/页", value: 200 },
      ],
      queryForm: {
        text: "",
        day_range: [],
        postofficeid: null,
        transport_kind: undefined,
        vehicle_state: undefined,
        own_type: undefined,
        section: undefined,
        postline: "",
      },
      spostoffices: [],
      postoffices: [],
      postlines: [],
      vehicles: [],
      sections: [],
      gps_states: [],
      task_states: [],
      vehicle_states: [],
      own_types: [],
      drivers: [],
      platforms: [],
      start_day_menu: false,
      end_day_menu: false,
      plan_date_menu: false,
      valid: true,
      headers: [
        { title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 50, align: "center", fixed: "left" },
        { title: "派押局", dataIndex: "postoffice", scopedSlots: { customRender: "postoffice" }, width: 100, align: "center", fixed: "left" },
        { title: "线路", dataIndex: "linename", scopedSlots: { customRender: "linename" }, width: 120, align: "center", fixed: "left" },
        { title: "日期", dataIndex: "plandate2", scopedSlots: { customRender: "plandate2" }, width: 100, align: "center", fixed: "left" },
        { title: "车牌号", dataIndex: "vehicle_number", scopedSlots: { customRender: "vehicle_number" }, width: 100, align: "center" },
        { title: "所属类型", dataIndex: "own_type", scopedSlots: { customRender: "own_type" }, width: 100, align: "center" },
        { title: "挂箱号", dataIndex: "vehicle_gnumber", scopedSlots: { customRender: "vehicle_gnumber" }, width: 100, align: "center" },
        { title: "派车单号", dataIndex: "dispatch_no", scopedSlots: { customRender: "dispatch_no" }, width: 120, align: "center" },
        { title: "车型", dataIndex: "vehicle_type", scopedSlots: { customRender: "vehicle_type" }, width: 100, align: "center" },
        { title: "司机", dataIndex: "driver_name", scopedSlots: { customRender: "driver_name" }, width: 100, align: "center" },
        { title: "联系电话", dataIndex: "driver_mobile", scopedSlots: { customRender: "driver_mobile" }, width: 120, align: "center" },
        { title: "车辆状态", dataIndex: "vehicle_state", scopedSlots: { customRender: "vehicle_state" }, width: 100, align: "center" },
        { dataIndex: "vehicle_time", slots: { title: "H_vehicle_time" }, scopedSlots: { customRender: "vehicle_time" }, width: 170, align: "center" },
        { title: "任务状态", dataIndex: "task_state", scopedSlots: { customRender: "task_state" }, width: 100, align: "center" },
        { title: "GPS状态", dataIndex: "gps_state", scopedSlots: { customRender: "gps_state" }, width: 100, align: "center" },
        { title: "运价(元)", dataIndex: "price", scopedSlots: { customRender: "price" }, width: 100, align: "center" },
        { title: "物流平台", dataIndex: "platform", scopedSlots: { customRender: "platform" }, width: 100, align: "center" },
        { title: "平台单号", dataIndex: "platform_no", scopedSlots: { customRender: "platform_no" }, width: 100, align: "center" },
        { title: "备注", dataIndex: "remark", scopedSlots: { customRender: "remark" }, width: 150, align: "center" },
        { title: "调车人", dataIndex: "create_by", scopedSlots: { customRender: "create_by" }, width: 120, align: "center" },
        { title: "创建时间", dataIndex: "create_time", scopedSlots: { customRender: "create_time" }, width: 150, align: "center" },
        { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 150, align: "center" },
      ],
      page: 1,
      limit: 20,
      list: [],
      length: 0,
      count: 0,
      height: 600,
      model: false,
      form: {},
      modeltitle: "",
      vrules: {
        required: (value) => !!value || "不能为空",
      },
      updateForm: {},
      updateModel: false,
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
    vehicles1() {
      return this.vehicles.filter(n => n.type === 1 || n.type === 3);
    },
    vehicles2() {
      return this.vehicles.filter(n => n.type === 2);
    },
    flines() {
      return this.postlines.filter(n => n.postofficeid === this.form.postofficeid);
    },
  },
  components: {},
  watch: {
    page() {
      this.getdata();
    },
    limit() {
      if (this.page !== 1) this.page = 1;
      else this.getdata();
    },
  },
  mounted() {
    this.height = window.innerHeight - 400;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 400;
    };
    let start_day = this.$moment().format('YYYY-MM-DD');
    let end_day = this.$moment().format('YYYY-MM-DD');
    this.queryForm = {
      text: "",
      day_range: [start_day, end_day],
      postofficeid: null,
      transport_kind: undefined,
      vehicle_state: undefined,
      own_type: undefined,
      section: undefined,
      postline: "",
    };
    this.page = 1;
    this.list = [];
    this.length = 0;
    this.count = 0;
  },
  activated() {
    this.getdata();
  },
  methods: {
    getdata(action) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/dispatchplan/list", { page: this.page, limit: this.limit, ...this.queryForm, action }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          if (action === 'download' && res.data.url) {
            return this.$download(res.data.url, res.data.name);;
          }
          this.list = res.data.list;
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
          this.spostoffices = [
            { value: null, label: "全部" },
            ...res.data.spostoffices,
          ];
          this.postoffices = res.data.postoffices;
          this.postlines = res.data.postlines;
          this.vehicles = res.data.vehicles;
          this.drivers = res.data.drivers;
          this.sections = res.data.sections;
          this.own_types = res.data.own_types;
          this.vehicle_states = res.data.vehicle_states;
          this.task_states = res.data.task_states;
          this.gps_states = res.data.gps_states;
          this.platforms = res.data.platforms;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    add() {
      this.form = {
        _id: "",
        postofficeid: undefined,
        postlineid: undefined,
        plandate: "",
        vehicleid: undefined,
        vehiclegid: undefined,
        vehicletype: undefined,
        vehicle_gnumber: "",
        driverid: undefined,
        task_state: undefined,
        gps_state: undefined,
        price: "",
        platform: "",
        platform_no: "",
        dispatch_no: "",
      };
      this.modeltitle = "新增调度计划";
      this.model = true;
    },
    edit(item) {
      let vehicle = this.vehicles1.find(n => n.value === item.vehicleid);
      this.form = {
        _id: item._id,
        postofficeid: item.postofficeid || undefined,
        postlineid: item.postlineid,
        plandate: item.plandate,
        vehicleid: item.vehicleid,
        vehiclegid: item.vehiclegid,
        vehicletype: vehicle.type,
        vehicle_gnumber: vehicle.vehicle_gnumber,
        driverid: item.driverid,
        task_state: item.task_state || undefined,
        gps_state: item.gps_state || undefined,
        price: item.price || "",
        platform: item.platform || "",
        platform_no: item.platform_no || "",
        dispatch_no: item.dispatch_no || "",
      };
      this.modeltitle = "编辑调度计划";
      this.model = true;
    },
    ///保存派车单号
    saveDispatch_no(item) {
      if (!item.dispatch_no2) return;
      this.update(item._id, 'dispatch_no', item.dispatch_no2);
    },
    changeVehicle(v) {
      console.log('changeVehicle', v);
      let vehicle = this.vehicles1.find(n => n.value === v);
      this.form.vehicletype = vehicle.type;
      if (vehicle.type === 3) {
        this.form.vehicle_gnumber = vehicle.vehicle_gnumber;
      }
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/dispatchplan/save", { dataForm: this.form }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.model = false;
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cancelsave() {
      this.$refs.form.resetValidation();
      this.model = false;
    },
    changeTransportKind2(_id, v) {
      console.log('changeTransportKind2', v);
      this.update(_id, 'transport_kind2', v);
    },
    changeVehicleState(_id, v) {
      console.log('changeVehicleState', v);
      if (this.username === 'root') {
        let state = '';
        let timekey = '';
        if (v === 2) state = '装货中', timekey = '装车时间';
        else if (v === 3) state = '行驶中', timekey = '出发时间';
        else if (v === 4) state = '已到达', timekey = '到达时间';
        this.updateForm = {
          _id,
          key: 'vehicle_state',
          value: v,
          state,
          timekey,
          timevalue: ""
        };
        this.updateModel = true;
      }
      else {
        this.update(_id, 'vehicle_state', v);
      }
    },
    changeTaskState(_id, v) {
      console.log('changeTaskState', v);
      this.update(_id, 'task_state', v);
    },
    changeGpsState(_id, v) {
      console.log('changeGpsState', v);
      this.update(_id, 'gps_state', v);
    },
    update(_id, key, value) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/dispatchplan/update", { _id, key, value }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    doUpdate() {
      if (!this.$refs.updateform.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/dispatchplan/update", this.updateForm).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.updateModel = false;
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cancelupdate() {
      this.$refs.updateform.resetValidation();
      this.updateModel = false;
    },
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/dispatchplan/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .row+.row {
  margin-top: 0;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>